import {
  SIGNIN,
  SIGNOUT,
  SAVE_USER,
  REQUEST_USER_PROFILE
} from '../actions/types';

function user(state = {}, action) {
  switch(action.type) {
    case SIGNIN:
      return Object.assign({}, state, {
        isLoggedIn: true,
        isFetching: false,
        error: null
      });
    case SIGNOUT:
      return Object.assign({}, state, {
        isLoggedIn: false,
        isFetching: false,
        error: action.error
      });
    case SAVE_USER:
      return Object.assign({}, state, {
        isLoggedIn: true,
        isFetching: false,
        displayName: action.payload.displayName,
        profileImageURL: action.payload.profileImageURL,
        email: action.payload.email,
        dfpTraffickerId: action.payload.dfpTraffickerId,
        roleName: action.payload.roleName,
        error: null
      });
    case REQUEST_USER_PROFILE:
      return Object.assign({}, state, {
        isFetching: true,
        error: null
      });
    default: {
      return state;
    }
  }
}

export default user;
